import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatCurrency } from '../../../../utils/Helpers'
import { PharmaciesFiltersContext } from '../../../../context/PharmaciesFiltersContext'
import { STATUS_CANCELLED } from '../../../../types/Order'

const GET_CANCELED_ORDERS = gql`
  query FinishOrders($filters: JSON) {
    ordersAggs(
      filters: $filters,
      size: 0,
      query: {
        bool: {
          filter: [
            {
              term: {
                status_translate_keyword: {
                  value: "${STATUS_CANCELLED}"
                }
              }
            }
          ]
        }
      },
      aggs: {
        totals: {
          sum: {
            field: "total"
          }
        }
      }
    ) {
      aggregations
    }
  }
`

const QuantityQueue = (): JSX.Element => {
  const { filters } = useContext(PharmaciesFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_CANCELED_ORDERS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Valor total de pedidos cancelados (R$) - Sem frete" number={formatCurrency(data.ordersAggs.aggregations.totals.value)} color={Colors.red} />
  )
}

export default QuantityQueue
